// extracted by mini-css-extract-plugin
export default {"objectName":"ObjectEditing_objectName__bYSg9","wrapper":"ObjectEditing_wrapper__DaEXY"};